 import React from "react";
import "./water.css";

import Navbar from "../../components/Navbar"; 
import SecondNavbar from "../../components/SecondNavbar";
import Footer from "../../components/Footer";    

import heroImg from "../../assets/water.jpg";
import aboutImg from "../../assets/AboutImg.jpg";
import factoryImg from "../../assets/FactoryImg.jpg";
import plasticImg from "../../assets/PlasticImg.jpg";
import impactImg from "../../assets/ImpactImg.jpg";

export default function WaterPollution() {
  return (
    <div className="water-page">

      <Navbar />
      <SecondNavbar />

      <section className="wp-hero">
        <div className="wp-hero-text">
          <h1>Water Pollution <br/> <span>The Silent Killer</span></h1>
          <p>
            Clean water is becoming the rarest resource on Earth. In Pakistan, 90% of our water is contaminated. 
            Industrial waste, plastic and sewage are poisoning our rivers and oceans. This is the full report.
          </p>
        </div>
        <div className="wp-hero-img">
          <img src={heroImg} alt="polluted water"/>
        </div>
      </section>

      <section className="wp-about" id="about">
        <div className="wp-about-img">
          <img src={aboutImg} alt="dirty river"/>
        </div>
        <div className="wp-about-text">
          <h2>What is Water Pollution?</h2>
          <p>
            Water pollution is the contamination of water bodies like rivers, lakes, oceans, and groundwater by 
            harmful substances. These substances make water unsafe for drinking, farming, and for aquatic life.
          </p>
          <p>
            According to PCRWR, <b>90% of Pakistan's drinking water is contaminated</b> with bacteria, chemicals, and heavy metals. 
            The main reason is that <b>80% of industrial and sewage waste is dumped directly into rivers</b> without any treatment. 
            This is why diseases like Cholera, Typhoid, and Hepatitis are so common in our country.
          </p>
        </div>
      </section>

      <section className="wp-causes" id="causes">
        <h2>The Root Causes & Data</h2>
        <div className="wp-card-grid">
          
          <div className="wp-card">
            <img src={factoryImg} alt="factory"/>
            <h3>1. Industrial Waste</h3>
            <p>
              Textile, leather, and chemical factories are the biggest polluters. They release heavy metals like 
              lead, mercury, chromium, and toxic dyes directly into rivers. 
            </p>
            <p><b>Data:</b> In Lahore, the Ravi River receives 500 million gallons of untreated industrial waste daily. 
            These chemicals stay in water and soil for 50+ years and cause cancer, kidney failure, and birth defects.</p>
          </div>

          <div className="wp-card">
            <img src={plasticImg} alt="plastic"/>
            <h3>2. Plastic & Garbage</h3>
            <p>
              Pakistan produces 3.3 million tons of plastic waste yearly. 90% is not recycled. Plastic bags block 
              drains and cause urban flooding.
            </p>
            <p><b>Data:</b> 8 million tons of plastic enter oceans every year. By 2050 there will be more plastic 
            than fish in the sea. 100,000 marine animals and 1 million seabirds die yearly after eating plastic.</p>
          </div>

          <div className="wp-card">
            <img src={impactImg} alt="sewage"/>
            <h3>3. Sewage & Farming Chemicals</h3>
            <p>
              Cities produce billions of gallons of sewage daily, but we have very few treatment plants. Raw sewage 
              full of bacteria goes into rivers.
            </p>
            <p><b>Data:</b> Karachi alone dumps 400 million gallons of untreated sewage into the Arabian Sea daily. 
            Fertilizers cause "algal blooms" which create 400+ "dead zones" in oceans where no life can survive.</p>
          </div>

        </div>
      </section>

      <section className="wp-effects">
        <div className="wp-effects-text">
          <h2>The Devastating Effects</h2>
          <p><b>On Human Health:</b> Dirty water is the #1 killer of children under 5 in Pakistan. It causes 
          diarrhea, Cholera, Typhoid, Hepatitis A & E. WHO says 485,000 people die yearly from waterborne diseases. 
          40% of all hospital beds in Pakistan are full of these patients. Arsenic in groundwater is causing cancer 
          in Sindh and Punjab.</p>
          
          <p><b>On Environment:</b> Chemical waste kills fish and destroys coral reefs. Plastic chokes turtles and birds. 
          The Indus Delta is dying because polluted water is killing mangrove forests. This makes our coastal cities 
          unsafe from storms and sea erosion.</p>

          <p><b>On Economy:</b> The World Bank estimates Pakistan loses <b>$12 Billion every year</b>. This money is 
          wasted on healthcare, cleaning rivers, and lost farming production. Polluted water cannot be used for crops 
          and reduces yield by 30%.</p>
        </div>
        <div className="wp-effects-img">
          <img src={impactImg} alt="dead fish"/>
        </div>
      </section>

      <section className="wp-solutions">
        <h2>How Can We Solve This Crisis?</h2>
        <div className="wp-solution-list">
          <div className="wp-sol-item">
            <h4>Government Must Act</h4>
            <p>Make water treatment plants mandatory for all factories. Put heavy fines on polluters. Build sewage 
            treatment plants in every major city. Ban single-use plastic completely.</p>
          </div>
          <div className="wp-sol-item">
            <h4>Industries Must Change</h4>
            <p>Invest in "Zero Liquid Discharge" technology. Recycle water inside factories. Stop using plastic packaging. 
            Fund river cleanup projects as part of CSR.</p>
          </div>
          <div className="wp-sol-item">
            <h4>Public Must Help</h4>
            <p>Install water filters at home. Do not throw oil, medicine, or plastic in drains. Reduce plastic use. 
            Join local cleanup drives. Teach your children to save water.</p>
          </div>
        </div>
      </section>

      <section className="wp-cta">
        <h2>There Is No Planet B. And No Water B.</h2>
        <p>The water crisis will destroy our future if we do not act today. We must protect our water now.</p>
      </section>

      <Footer />

    </div>
  );
}